import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const getNotFoundHeadElements = ({ title = 'BNB Chain - Build Web3 dApps on the Most Popular Blockchain', description = 'BNB Chain is the best blockchain for Web3 dApps with massive user bases. Developers can build easily with tutorials, grants, and ecosystem support.', colorMode = 'dark', } = {}) => {
    const dark = colorMode === 'dark';
    const styles = `
html {
    -webkit-text-size-adjust: 100%;
    font-family: system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
}

body {
    margin: 0;
}

#__next {
    color: ${dark ? '#fff' : '#181a1e'};
    font-family: "Space Grotesk", sans-serif;
}

.not-found {
    padding-top: 90px;
    padding-bottom: 140px;
    padding-inline-start: 40px;
    padding-inline-end: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    justify-content: center;
    background: ${dark ? '#14151A' : '#f7f7f8'};
    box-sizing: border-box;
}

.not-found div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.not-found h1 {
    font-size: 2rem;
    line-height: 2.5rem;
    margin-top: 16px;
    margin-bottom: 16px;
    font-weight: 700;
}

.not-found p {
    font-size: 1.25rem;
    line-height: 1.75rem;
    color: ${dark ? '#5C5F6A' : '#5C5F6A'};
    max-width: 792px;
    margin-top: 0;
    margin-bottom: 40px;
}

.not-found a {
    height: 48px;
    font-size: 1rem;
    line-height: 1.5rem;
    min-width: 96px;
    padding-inline-start: 24px;
    padding-inline-end: 24px;
    border-radius: 8px;
    display: inline-flex;
    appearance: none;
    align-items: center;
    justify-content: center;
    user-select: none;
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
    outline: 2px solid transparent;
    outline-offset: 2px;
    font-weight: 500;
    background: ${dark ? '#F7F7F8' : '#181A1E'};
    color: ${dark ? '#181A1E' : '#fff'};
    text-decoration: none;
    font-weight: 500;
}

.not-found a:hover {
    background: ${dark ? '#E1E2E5' : '#1E2026'};
}

.not-found img {
    width: 280px;
    aspect-ratio: auto 280 / 280;
}

@media (max-width: 767px) {
    .not-found h1 {
        font-size: 1.25rem;
        line-height: 1.75rem;
    }

    .not-found p {
        font-size: 1rem;
        line-height: 1.5rem;
    }

    .not-found a {
        height: 40px;
        font-size: 0.875rem;
        line-height: 1rem;
        min-width: 72px;
        padding-inline-start: 16px;
        padding-inline-end: 16px;
        border-radius: 8px;
    }
}
            `;
    return (_jsxs(_Fragment, { children: [_jsx("title", { children: title }), _jsx("meta", { name: "description", content: description }), _jsx("style", { dangerouslySetInnerHTML: { __html: styles } })] }));
};
export const NotFoundBodyElements = ({ title = 'Oops! Page Not Found', description = 'The page you are looking for might have been removed had its name changed or is temporarily unavailable.', aLink = 'https://www.bnbchain.org/', aText = 'Return Home', }) => {
    return (_jsx("section", { className: 'not-found', children: _jsxs("div", { children: [_jsx("img", { src: `https://cms-static.bnbchain.org/dcms/static/7fa6ae50-f047-4b74-b4a5-5225b7e00345.svg`, alt: "Page Not Found" }), _jsx("h1", { children: title }), _jsx("p", { children: description }), !!aLink && (_jsx("a", { href: aLink, target: "_self", children: aText }))] }) }));
};
